import { serverUrl } from '../config';
import { Letter } from '../components/Models';

type IdEntry<ID, V> = [ID, V];
export type GroupedArchive<L> = IdEntry<string, L[]>[];

export type LetterDirectionality = 'sent' | 'received';

export type ArchiveSummary = {
  id: string;
  correspondent_name: string;
  correspondent_id: string;
  recipient: string;
  relevant_date: string;
  directionality: LetterDirectionality;
  sender_id: string;
  title: string;
};

type WritingDeskResponse = {
  archiveLetters: GroupedArchive<ArchiveSummary>;
  drafts: Letter[];
  unreadLetters: Letter[];
};

export const fetchWritingDesk = (token: string) => async (): Promise<WritingDeskResponse> => {
  const fetchUrl = `${serverUrl}/api/writing-desk/`;
  const requestBody = {
    method: 'get',
    headers: { authorization: `Token ${token}` },
  };

  return await fetch(fetchUrl, requestBody).then((res) => res.json());
};
